<template>
  <div class="price-card">
    <div class="tip" v-if="$store.state.plat_id!='120'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 1是  2不是-->
            <img :src="$free" v-if="cardData.is_free==1"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
    :src="cardData.cover_mobile" alt="">

    </van-image>
    <div class="price-msg">
      <div class="price-name">{{ cardData.name }}</div>
      <!-- <div class="price-name ellipsis">{{ cardData.name }}</div> -->
      <!-- <div class="price-des ellipsis">{{ cardData.description }}</div> -->
      <div class="price" v-if="plat!=120 && parseFloat(cardData.price) && !$store.state.plat.priceHide" >¥ {{ cardData.price }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {
     plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  onLoad() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.price-card {
  width: 100%;
  height: 150px;
  margin-top: 18px;
  display: flex;
  padding: 0 18px;
  box-sizing: border-box;
  position: relative;
  .tip{
    position: absolute;
    top:0;
    left:18px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.price-card:last-of-type {
  margin-bottom: 0;
}

.price-cover {
  width: 266px;
  height: 150px;
  border-radius: 12px;
  overflow: hidden;
  display: block;
  flex: 0 0 266px;
  margin-right: 26px;
}

.price-msg {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}

.price-name {
  font-size: 28px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 20px;
}

.price-des {
  font-size: 24px;
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 24px;
}

.price {
  font-size: 24px;
  color: #ff4d41;
  font-weight: 600;
}
</style>>
